module.exports = __webpack_public_path__ + "img/1_023.7f96ddb4.jpg";